/* MnZ PDP v4: Verhalten der Sections unter/neben der Buybox.
   Karussells (Scroll-Snap + Pfeile/Zähler), Galerie-Steuerung Handy (slick des Themes), Rating-Zeile (Sprung + optional Live-Wert),
   "Mehr lesen", Vorher/Nachher-Regler, REVIEWS.io-Widget (lazy, mit Fallback). Mehrfach eingebunden -> nur einmal ausführen. */
(function () {
  'use strict';
  if (window.MnzPdp) return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $all(root, sel) {
    return Array.prototype.slice.call(root.querySelectorAll(sel));
  }

  /* ---------- Zahlenformat (de) ---------- */
  function formatDe(num, decimals) {
    var fixed = Number(num).toFixed(decimals);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return parts.join(',');
  }

  /* ---------- Karussell ---------- */
  function initCarousel(el) {
    if (el.__mnzCarousel) return;
    el.__mnzCarousel = true;
    var track = el.querySelector('.mnz-carousel__track');
    var nav = el.querySelector('[data-mnz-carousel-nav]');
    if (!track || !nav) return;
    var prev = nav.querySelector('[data-mnz-prev]');
    var next = nav.querySelector('[data-mnz-next]');
    var cur = nav.querySelector('[data-mnz-cur]');
    var total = nav.querySelector('[data-mnz-total]');
    var items = $all(track, '.mnz-carousel__item');
    if (total) total.textContent = String(items.length);

    function step() {
      if (items.length < 2) return track.clientWidth;
      return items[1].offsetLeft - items[0].offsetLeft;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var fits = max <= 1;
      nav.hidden = fits;
      if (fits) return;
      var s = step() || 1;
      var idx = Math.round(track.scrollLeft / s);
      if (track.scrollLeft >= max - 1) {
        // am Ende: letzte sichtbare Kachel zählt
        var visible = Math.max(1, Math.round(track.clientWidth / s));
        idx = Math.max(idx, items.length - visible);
      }
      if (cur) cur.textContent = String(Math.min(items.length, idx + 1));
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;
    }

    function go(dir) {
      var s = step();
      var visible = Math.max(1, Math.floor((track.clientWidth + 1) / (s || 1)));
      var target = Math.round(track.scrollLeft / (s || 1)) + dir * visible;
      target = Math.max(0, Math.min(items.length - 1, target));
      var left = items[target] ? items[target].offsetLeft - items[0].offsetLeft : 0;
      track.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { go(-1); });
    next.addEventListener('click', function () { go(1); });
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; update(); });
    }, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
    else window.addEventListener('resize', update);
    update();
  }

  /* ---------- Galerie-Steuerung Handy (slick des Themes) ---------- */
  function initGalleryNav(gallery) {
    if (gallery.__mnzNav) return;
    var slideshow = gallery.querySelector('.product-slideshow');
    var jq = window.jQuery;
    if (!slideshow || !jq) return;
    if (!slideshow.classList.contains('slick-initialized')) {
      // slick startet im Theme-Bundle; auf die Klasse warten
      var mo = new MutationObserver(function () {
        if (slideshow.classList.contains('slick-initialized')) {
          mo.disconnect();
          initGalleryNav(gallery);
        }
      });
      mo.observe(slideshow, { attributes: true, attributeFilter: ['class'] });
      return;
    }
    gallery.__mnzNav = true;
    var $s = jq(slideshow);
    var count = $s.slick('getSlick').slideCount;
    if (count < 2) return;

    var nav = document.createElement('div');
    nav.className = 'mnz-gallery-nav';
    var html = '<button type="button" class="mnz-pdp-reset mnz-carousel__btn" data-dir="-1" aria-label="Vorheriges Bild">' +
      '<svg class="mnz-pdp-icon feather" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m14.5 5.5-6.5 6.5 6.5 6.5"/></svg></button>' +
      '<span class="mnz-gallery-nav__dots" aria-hidden="true">';
    for (var i = 0; i < count; i++) html += '<span class="mnz-gallery-nav__dot"></span>';
    html += '</span><span class="mnz-carousel__count" aria-live="polite"><span class="mnz-vh">Bild </span><span data-cur>1</span> / ' + count + '</span>' +
      '<button type="button" class="mnz-pdp-reset mnz-carousel__btn" data-dir="1" aria-label="Nächstes Bild">' +
      '<svg class="mnz-pdp-icon feather" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m9.5 5.5 6.5 6.5-6.5 6.5"/></svg></button>';
    nav.innerHTML = html;
    var mainImage = gallery.querySelector('.main-image');
    mainImage.parentNode.insertBefore(nav, mainImage.nextSibling);
    var dots = $all(nav, '.mnz-gallery-nav__dot');
    var curEl = nav.querySelector('[data-cur]');
    var btns = $all(nav, 'button');

    function set(index) {
      dots.forEach(function (d, j) { d.classList.toggle('is-active', j === index); });
      curEl.textContent = String(index + 1);
      btns[0].disabled = index === 0;
      btns[1].disabled = index === count - 1;
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        $s.slick(b.getAttribute('data-dir') === '1' ? 'slickNext' : 'slickPrev');
      });
    });
    $s.on('afterChange', function (e, slick, index) { set(index); });
    set($s.slick('slickCurrentSlide'));
    gallery.classList.add('mnz-gallery-nav-ready');
  }

  /* ---------- R3: Galeriebilder 2 bis n erst bei Bedarf laden ----------
     snippets/mnz-gallery-image.liquid gibt ihnen nur data-mnz-srcset/-src. Geladen wird, wenn das Bild sichtbar wird
     (IntersectionObserver, beachtet das overflow der Slideshow: versteckte Slides zählen nicht), wenn die Slideshow
     dorthin wechselt (beforeChange, dazu das nächste), bei Maus/Fokus/Finger auf der Galerie (nächstes Bild) und bei
     Maus/Fokus auf einem Thumbnail (dieses Bild). */
  function hydrateImg(img) {
    var set = img.getAttribute('data-mnz-srcset');
    if (set === null) return;
    var sz = img.getAttribute('data-mnz-sizes');
    if (sz) img.setAttribute('sizes', sz);
    if (set) img.setAttribute('srcset', set);
    var src = img.getAttribute('data-mnz-src');
    if (src) img.setAttribute('src', src);
    img.removeAttribute('data-mnz-srcset');
    img.removeAttribute('data-mnz-src');
    img.removeAttribute('data-mnz-sizes');
  }

  function initGalleryLazy(gallery) {
    if (gallery.__mnzLazy) return;
    var pending = $all(gallery, 'img[data-mnz-srcset]');
    if (!pending.length) return;
    gallery.__mnzLazy = true;

    function slides() { return $all(gallery, '.product-slideshow .slide'); }
    function hydrateMedia(id) {
      if (!id) return;
      slides().forEach(function (sl) {
        if (sl.getAttribute('data-media-id') === String(id)) $all(sl, 'img[data-mnz-srcset]').forEach(hydrateImg);
      });
    }
    function hydrateIndex(i) {
      var real = $all(gallery, '.product-slideshow .slide:not(.slick-cloned)');
      if (!real.length) real = slides();
      if (i < 0 || i >= real.length) return;
      hydrateMedia(real[i].getAttribute('data-media-id'));
    }
    function current() {
      var jq = window.jQuery;
      var ss = gallery.querySelector('.product-slideshow');
      if (jq && ss && ss.classList.contains('slick-initialized')) {
        try { return jq(ss).slick('slickCurrentSlide'); } catch (e) { /* weiter */ }
      }
      return 0;
    }

    /* Desktop (ab 768 px) blendet die Slideshow über (fade): alle Slides liegen übereinander im Bild. Deshalb zählt
       für den Observer nur die aktive Slide; die übrigen lädt der Slide-Wechsel (beforeChange/Thumbnail). Der Observer
       startet erst, wenn die Slideshow steht (sonst liegen die Slides kurz untereinander im Lazy-Abstand). */
    function inactiveSlide(img) {
      var sl = img.closest ? img.closest('.slide') : null;
      var ssEl = sl ? sl.closest('.product-slideshow') : null;
      return !!(ssEl && ssEl.classList.contains('slick-initialized') && !sl.classList.contains('slick-active'));
    }
    function observe() {
      if (gallery.__mnzIo) return;
      gallery.__mnzIo = true;
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && !inactiveSlide(en.target)) { io.unobserve(en.target); hydrateImg(en.target); }
          });
        }, { rootMargin: '0px 0px 200px 0px' });
        $all(gallery, 'img[data-mnz-srcset]').forEach(function (img) { io.observe(img); });
      } else {
        pending.forEach(hydrateImg);
      }
    }
    var ss0 = gallery.querySelector('.product-slideshow');
    if (ss0 && !ss0.classList.contains('slick-initialized') && window.jQuery) {
      window.jQuery(ss0).one('init', function () { setTimeout(observe, 0); });
      setTimeout(observe, 4000);
    } else {
      observe();
    }

    var warm = function () {
      hydrateIndex(current() + 1);
    };
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (t) {
      gallery.addEventListener(t, warm, { passive: true });
    });
    $all(gallery, '.thumbnails [data-media-id]').forEach(function (th) {
      var go = function () { hydrateMedia(th.getAttribute('data-media-id')); };
      th.addEventListener('pointerenter', go, { passive: true });
      th.addEventListener('focus', go);
      th.addEventListener('click', go);
    });

    var ss = gallery.querySelector('.product-slideshow');
    var jq = window.jQuery;
    if (ss && jq) {
      jq(ss).on('beforeChange', function (e, slick, cur, next) {
        hydrateIndex(next);
        hydrateIndex(next + 1);
      });
    }

    /* Lightbox des Themes (theme.js klont beim Klick auf a.show-gallery die Bildhüllen als Thumbnails):
       vorher alle Bilder laden (Capture-Phase, läuft vor dem delegierten jQuery-Handler am document) */
    gallery.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a.show-gallery')) $all(gallery, 'img[data-mnz-srcset]').forEach(hydrateImg);
    }, true);
  }

  /* ---------- R5: KI-Hinweis (Icon + Popover, snippets/mnz-ai-badge.liquid) ----------
     Tap/Klick/Enter/Leertaste schaltet das Popover, Tap daneben oder Esc schließt. Alle Zeiger-/Klick-Ereignisse auf dem Icon
     werden in der Capture-Phase am document abgefangen: so erreicht der Tap weder den Lightbox-Link (theme.js, delegiert),
     noch das Wischen der Slideshow (slick, mousedown/touchstart), noch das Ziehen am Vorher/Nachher-Regler (pointerdown),
     noch das label der Extra-Farben-Karte. */
  var aiSeq = 0;
  function aiWire(wrap) {
    var btn = wrap.querySelector('[data-mnz-ai-btn]');
    var pop = wrap.querySelector('[data-mnz-ai-pop]');
    if (!btn || !pop || btn.getAttribute('aria-controls')) return;
    aiSeq += 1;
    pop.id = 'mnz-ai-pop-' + aiSeq;
    btn.setAttribute('aria-controls', pop.id);
    btn.setAttribute('aria-describedby', pop.id);
  }
  function aiSet(wrap, open) {
    aiWire(wrap);
    wrap.classList.toggle('is-open', open);
    var btn = wrap.querySelector('[data-mnz-ai-btn]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function aiCloseAll(except) {
    $all(document, '.mnz-ai.is-open').forEach(function (w) { if (w !== except) aiSet(w, false); });
  }
  function initAiGlobal() {
    if (document.__mnzAi) return;
    document.__mnzAi = true;
    var inAi = function (e) { return e.target && e.target.closest ? e.target.closest('[data-mnz-ai]') : null; };
    ['pointerdown', 'mousedown', 'touchstart', 'pointerup', 'mouseup', 'touchend', 'dblclick'].forEach(function (t) {
      document.addEventListener(t, function (e) {
        if (inAi(e)) e.stopPropagation();
      }, { capture: true, passive: true });
    });
    document.addEventListener('click', function (e) {
      var wrap = inAi(e);
      if (!wrap) {
        aiCloseAll(null);
        return;
      }
      e.stopPropagation();
      e.preventDefault();
      if (!(e.target.closest('[data-mnz-ai-btn]'))) return; /* Tap aufs Popover selbst: offen lassen */
      var open = !wrap.classList.contains('is-open');
      aiCloseAll(wrap);
      aiSet(wrap, open);
    }, true);
    /* Esc schließt nur das Popover: auch das zugehörige keyup abfangen (die Lightbox des Themes schließt auf keyup) */
    var escTaken = false;
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      var open = document.querySelector('.mnz-ai.is-open');
      if (!open) return;
      e.stopPropagation();
      escTaken = true;
      var had = open.contains(document.activeElement);
      aiCloseAll(null);
      if (had) open.querySelector('[data-mnz-ai-btn]').focus();
    }, true);
    document.addEventListener('keyup', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && escTaken) {
        escTaken = false;
        e.stopPropagation();
      }
    }, true);
  }

  /* Lightbox (.gallery-viewer hängt am body): ein Icon für das große Bild, nur wenn die Galerie selbst Icons zeigt
     (Setting ai_badge_show aus = display none am Galerie-Icon). */
  function initViewerBadge() {
    if (document.__mnzViewerBadge || !('MutationObserver' in window)) return;
    var src = document.querySelector('.mnz-product .mnz-ai--gallery');
    if (!src) return;
    document.__mnzViewerBadge = true;
    var mo = new MutationObserver(function () {
      var v = document.querySelector('.gallery-viewer');
      if (!v || v.querySelector('.mnz-ai--viewer')) return;
      var g = document.querySelector('.mnz-product .mnz-ai--gallery');
      if (!g || window.getComputedStyle(g).display === 'none') return;
      var b = g.cloneNode(true);
      b.className = 'mnz-ai mnz-ai--viewer';
      b.classList.remove('is-open');
      var bb = b.querySelector('[data-mnz-ai-btn]');
      bb.removeAttribute('aria-controls');
      bb.removeAttribute('aria-describedby');
      bb.setAttribute('aria-expanded', 'false');
      b.querySelector('[data-mnz-ai-pop]').removeAttribute('id');
      v.appendChild(b);
      aiWire(b);
    });
    mo.observe(document.body, { childList: true });
  }

  /* ---------- R3: voraussichtliches Lieferdatum aktuell halten (Seite kann gecacht sein) ---------- */
  var DE_WD = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
  var DE_MO = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  function formatDeliveryDate(days, now) {
    var d = new Date((now || new Date()).getTime());
    d.setDate(d.getDate() + days);
    return DE_WD[d.getDay()] + ', ' + d.getDate() + '. ' + DE_MO[d.getMonth()];
  }

  /* Shared fixed-set / photo / AI window: Berlin date-only calendar arithmetic. */
  function formatFixedSetDelivery(now) {
    var parts = new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit'}).formatToParts(now || new Date());
    var date = {};
    parts.forEach(function (part) { date[part.type] = part.value; });
    var y = Number(date.year), m = Number(date.month), d = Number(date.day);
    function plus(days) { return new Date(Date.UTC(y, m - 1, d + days)); }
    var start = plus(8), end = plus(12);
    // Compact German range; years remain in calendar arithmetic, not in the label.
    var options = {day: 'numeric', month: 'long', timeZone: 'UTC'};
    var fmt = new Intl.DateTimeFormat('de-DE', options);
    var sameMonth = start.getUTCFullYear() === end.getUTCFullYear() && start.getUTCMonth() === end.getUTCMonth();
    var first = sameMonth ? start.getUTCDate() + '.' : fmt.format(start);
    return 'Voraussichtliche Lieferung: ' + first + '–' + fmt.format(end);
  }
  function initFixedSetDelivery() {
    var nodes = document.querySelectorAll('[data-mnz-fixed-delivery], [data-mnz-delivery-window]');
    if (!nodes.length) return;
    try {
      var label = formatFixedSetDelivery();
      Array.prototype.forEach.call(nodes, function (el) { if (el.textContent !== label) el.textContent = label; });
    } catch (e) { /* Keep useful 8–12 Tage fallback on older browsers. */ }
  }
  document.addEventListener('visibilitychange', function () { if (!document.hidden) initFixedSetDelivery(); });
  window.addEventListener('pageshow', initFixedSetDelivery);
  // Recompute across Berlin midnight, including tabs left open or resumed.
  window.setInterval(initFixedSetDelivery, 30000);

  function initDeliveryDates(root) {
    initFixedSetDelivery();
    $all(root, '[data-mnz-date]').forEach(function (el) {
      var days = parseInt(el.getAttribute('data-days'), 10);
      if (days > 0) el.textContent = formatDeliveryDate(days);
    });
  }

  /* ---------- Rating-Zeile ---------- */
  function scrollToTarget(target) {
    var header = document.querySelector('.section-header, #shopify-section-header, .pageheader');
    var offset = 12;
    if (header) {
      var pos = getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') offset += header.getBoundingClientRect().height;
    }
    var y = target.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top: Math.max(0, y), behavior: reduceMotion ? 'auto' : 'smooth' });
    try { target.focus({ preventScroll: true }); } catch (e) { /* alte Browser */ }
  }

  function initRating(link) {
    if (link.__mnz) return;
    link.__mnz = true;
    link.addEventListener('click', function (e) {
      var sel = link.getAttribute('href') || '';
      if (sel.charAt(0) !== '#') return;
      var target = document.getElementById(sel.slice(1));
      if (!target) return;
      e.preventDefault();
      scrollToTarget(target);
      if (window.history && history.replaceState) history.replaceState(null, '', window.location.pathname + window.location.search + sel);
    });
    var store = link.getAttribute('data-store');
    if (!store || !window.fetch) return;
    fetch('https://api.reviews.io/merchant/reviews?per_page=1&store=' + encodeURIComponent(store))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.stats) return;
        var avg = parseFloat(d.stats.average_rating);
        var total = parseInt(d.stats.total_reviews, 10);
        if (!(avg > 0) || !(total > 0)) return;
        var v = link.querySelector('[data-mnz-rating-value]');
        var c = link.querySelector('[data-mnz-rating-count]');
        var f = link.querySelector('[data-mnz-rating-fill]');
        if (v) v.textContent = formatDe(avg, 2);
        if (c) c.textContent = formatDe(total, 0);
        if (f) f.style.width = Math.min(100, (avg / 5) * 100).toFixed(1) + '%';
        var vh = link.querySelector('.mnz-vh');
        if (vh) vh.textContent = ', ' + formatDe(avg, 2) + ' von 5 Sternen, zu den Bewertungen springen';
      })
      .catch(function () { /* Setting-Wert bleibt stehen */ });
  }

  /* ---------- Mehr lesen ---------- */
  function initReadMore(btn) {
    if (btn.__mnz) return;
    btn.__mnz = true;
    var grid = document.getElementById(btn.getAttribute('aria-controls'));
    var label = btn.querySelector('[data-mnz-readmore-label]');
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') !== 'true';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (grid) grid.classList.toggle('is-open', open);
      if (label) label.textContent = btn.getAttribute(open ? 'data-less' : 'data-more');
    });
  }

  /* ---------- Vorher/Nachher ---------- */
  function initCompare(box) {
    if (box.__mnz) return;
    box.__mnz = true;
    var range = box.querySelector('.mnz-compare__range');
    var before = range ? range.getAttribute('data-before') || '' : '';

    function setPos(p) {
      p = Math.max(0, Math.min(100, p));
      box.style.setProperty('--mnz-pos', p + '%');
      if (range) {
        range.value = String(Math.round(p));
        range.setAttribute('aria-valuetext', Math.round(p) + ' % ' + before);
      }
    }

    if (range) {
      range.addEventListener('input', function () { setPos(parseFloat(range.value)); });
    }

    // Ziehen: Maus sofort, Finger erst wenn die Bewegung eher waagerecht ist (touch-action: pan-y lässt senkrecht scrollen)
    var active = null;
    function posFromEvent(e) {
      var r = box.getBoundingClientRect();
      return ((e.clientX - r.left) / r.width) * 100;
    }
    box.addEventListener('pointerdown', function (e) {
      if (e.button !== undefined && e.button !== 0) return;
      active = { id: e.pointerId, x: e.clientX, y: e.clientY, drag: e.pointerType === 'mouse' };
      if (active.drag) {
        e.preventDefault();
        try { box.setPointerCapture(e.pointerId); } catch (err) { /* egal */ }
        setPos(posFromEvent(e));
      }
    });
    box.addEventListener('pointermove', function (e) {
      if (!active || e.pointerId !== active.id) return;
      if (!active.drag) {
        var dx = Math.abs(e.clientX - active.x);
        var dy = Math.abs(e.clientY - active.y);
        if (dx < 6 && dy < 6) return;
        if (dy > dx) { active = null; return; }
        active.drag = true;
        try { box.setPointerCapture(e.pointerId); } catch (err) { /* egal */ }
      }
      setPos(posFromEvent(e));
    });
    function end(e) {
      if (active && e.pointerId === active.id) {
        if (!active.drag && e.type === 'pointerup' && e.pointerType !== 'mouse') {
          // Tippen setzt die Linie an die Stelle
          setPos(posFromEvent(e));
        }
        active = null;
      }
    }
    box.addEventListener('pointerup', end);
    box.addEventListener('pointercancel', function () { active = null; });
  }

  /* ---------- REVIEWS.io Shop-Bewertungen (R2: eigene Liste, lazy; R3: ohne Kurs-Bewertungen) ---------- */
  var REVIEW_SKIP = /leider|enttäusch|schade|nicht zufrieden|reklam|mangelhaft|kaputt|abgebrochen|brechen|manko|das einzige|fehlt|verbesser|könnte|noch nicht|schwierigkeit/i;
  /* R3: Bewertungen mit Kurs-Bezug raus (die Seite verkauft ein Produkt, keinen Kurs) */
  var REVIEW_COURSE = /kurs|video|lektion|simon|lehrer|lehrmethode|anleitung|tutorial|meisterkreis|unterricht|erkl(ä|ae)r|klärung|lern|übung|üben|tipps|tricks|community|gebucht|workshop|youtube|livestream|webinar|mentor|coach|e-book|ebook|herangehensweise|schritt für schritt|zeichentalent|zeichenerfahrung|informationen/i;
  /* R3: Material-, Service-, Versand- und Qualitätsbewertungen zuerst */
  var REVIEW_PREFER = /versand|liefer|verpack|qualität|hochwertig|stift|farbe|papier|material|service|kontakt|bestell|paket|pinsel|leinwand|ware|produkt|kundenorientiert|team/i;

  function reviewText(r) {
    return (r && r.comments ? String(r.comments) : '').replace(/\s+/g, ' ').trim();
  }

  /* opts: fiveOnly (Standard true), pinned (Array von store_review_id, Vorrang), minCards (Standard 6):
     liefert erst 5 Sterne; sind es weniger als minCards, kommen 4 Sterne dazu (fiveOnly=false: 4 und 5 Sterne gleich). */
  function pickReviews(list, opts) {
    opts = opts || {};
    var fiveOnly = opts.fiveOnly !== false;
    var minCards = opts.minCards || 6;
    var pinned = (opts.pinned || []).map(String);
    var seen = {};
    var base = (list || []).filter(function (r) {
      if (!r) return false;
      var t = reviewText(r);
      if (!t || seen[t]) return false;
      var id = String(r.store_review_id || '');
      var isPinned = id && pinned.indexOf(id) !== -1;
      if (!isPinned) {
        if (r.rating < 4 || t.length < 60 || t.length > 480) return false;
        if (REVIEW_SKIP.test(t) || REVIEW_COURSE.test(t)) return false;
      }
      seen[t] = true;
      return true;
    });
    function rank(r) {
      var id = String(r.store_review_id || '');
      var p = pinned.indexOf(id);
      if (p !== -1) return p - 1000;
      return REVIEW_PREFER.test(reviewText(r)) ? 0 : 1;
    }
    function sort(arr) {
      return arr.sort(function (x, y) {
        var d = rank(x) - rank(y);
        if (d) return d;
        return String(y.date_created || '').localeCompare(String(x.date_created || ''));
      });
    }
    var isPin = function (r) { return pinned.indexOf(String(r.store_review_id || '')) !== -1; };
    var five = base.filter(function (r) { return r.rating === 5 || isPin(r); });
    if (fiveOnly && five.length >= minCards) return sort(five);
    if (fiveOnly) {
      // zu wenige 5-Sterne-Karten: 4 Sterne hinten anhängen
      var four = base.filter(function (r) { return r.rating === 4 && !isPin(r); });
      return sort(five).concat(sort(four));
    }
    return sort(base);
  }

  function reviewerName(r) {
    var rv = r.reviewer || {};
    var first = String(rv.first_name || '').trim();
    var last = String(rv.last_name || '').trim();
    if (!first || /^anonym/i.test(first)) return 'Anonym';
    return first + (last ? ' ' + last.charAt(0) + '.' : '');
  }

  function isVerified(r) {
    return !!(r && r.reviewer && r.reviewer.verified_buyer === 'yes');
  }

  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  // date_created kommt als "YYYY-MM-DD HH:MM:SS"; ohne gültiges Datum kein Datum auf der Karte
  function reviewDate(r) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String((r && r.date_created) || ''));
    if (!m) return null;
    var mo = parseInt(m[2], 10);
    var d = parseInt(m[3], 10);
    if (mo < 1 || mo > 12 || d < 1 || d > 31) return null;
    return { iso: m[1] + '-' + m[2] + '-' + m[3], text: d + '. ' + MONTHS[mo - 1] + ' ' + m[1] };
  }

  function initReviews(wrap) {
    if (wrap.__mnz) return;
    wrap.__mnz = true;
    var section = wrap.closest('.mnz-reviews');
    var fallback = section ? section.querySelector('[data-mnz-reviews-fallback]') : null;
    var list = wrap.querySelector('[data-mnz-reviews-list]');
    var more = wrap.querySelector('[data-mnz-reviews-more]');
    var all = wrap.querySelector('[data-mnz-reviews-all]');
    var starTpl = wrap.querySelector('[data-mnz-reviews-star]');
    var starSvg = starTpl ? starTpl.innerHTML : '';
    var checkTpl = wrap.querySelector('[data-mnz-reviews-check]');
    var checkSvg = checkTpl ? checkTpl.innerHTML : '';
    var verifiedLabel = wrap.getAttribute('data-verified-label') || '';
    var showDate = wrap.getAttribute('data-show-date') !== 'false';
    var perPage = parseInt(wrap.getAttribute('data-per-page'), 10) || 6;
    var max = parseInt(wrap.getAttribute('data-max'), 10) || 12;
    var maxPages = parseInt(wrap.getAttribute('data-pages'), 10) || 4;
    var fiveOnly = wrap.getAttribute('data-five-only') === 'true';
    var pinned = (wrap.getAttribute('data-pinned') || '').split(/[^0-9]+/).filter(Boolean);
    var pool = [];
    var shown = 0;

    function fail() {
      if (fallback) fallback.hidden = false;
      wrap.hidden = true;
    }

    function card(r) {
      var li = document.createElement('li');
      li.className = 'mnz-review';
      li.setAttribute('data-review-id', String(r.store_review_id || ''));
      var stars = document.createElement('p');
      stars.className = 'mnz-review__stars';
      var n = Math.max(1, Math.min(5, parseInt(r.rating, 10) || 5));
      stars.setAttribute('aria-label', n + ' von 5 Sternen');
      stars.setAttribute('data-rating', String(n));
      stars.innerHTML = new Array(n + 1).join(starSvg);
      var text = document.createElement('p');
      text.className = 'mnz-review__text';
      text.textContent = reviewText(r);
      var who = document.createElement('p');
      who.className = 'mnz-review__who';
      who.textContent = reviewerName(r);
      li.appendChild(stars);
      li.appendChild(text);
      li.appendChild(who);
      // R6: "Verifizierter Kauf" nur, wenn REVIEWS.io den Kauf als verifiziert markiert; Datum nur, wenn die API es liefert
      var verified = isVerified(r) && verifiedLabel;
      var date = showDate ? reviewDate(r) : null;
      if (verified || date) {
        var meta = document.createElement('p');
        meta.className = 'mnz-review__meta';
        if (verified) {
          var v = document.createElement('span');
          v.className = 'mnz-review__verified';
          v.innerHTML = checkSvg;
          v.appendChild(document.createTextNode(verifiedLabel));
          meta.appendChild(v);
        }
        if (date) {
          var t = document.createElement('time');
          t.className = 'mnz-review__date';
          t.setAttribute('datetime', date.iso);
          t.textContent = date.text;
          meta.appendChild(t);
        }
        li.appendChild(meta);
      }
      return li;
    }

    function showNext(n) {
      var end = Math.min(pool.length, max, shown + n);
      var first = null;
      for (var i = shown; i < end; i++) {
        var li = card(pool[i]);
        if (!first) first = li;
        list.appendChild(li);
      }
      shown = end;
      var canMore = shown < Math.min(pool.length, max);
      if (more) more.hidden = !canMore;
      if (all) all.hidden = canMore;
      return first;
    }

    if (more) {
      more.addEventListener('click', function () {
        var first = showNext(perPage);
        if (first) {
          first.setAttribute('tabindex', '-1');
          first.focus({ preventScroll: true });
        }
      });
    }

    function start() {
      if (!window.fetch) return fail();
      var store = wrap.getAttribute('data-store');
      var timer = setTimeout(function () { if (!shown) fail(); }, 12000);
      var raw = [];
      var stats = null;
      function enough() {
        // genug Karten mit Vorrang (angeheftet oder Material/Service/Versand), sonst weitere Seite
        var picked = pickReviews(raw, { fiveOnly: fiveOnly, pinned: pinned });
        var good = picked.filter(function (r) {
          return (fiveOnly ? r.rating === 5 : r.rating >= 4) && (pinned.indexOf(String(r.store_review_id)) !== -1 || REVIEW_PREFER.test(reviewText(r)));
        });
        var pinnedFound = pinned.every(function (id) { return raw.some(function (r) { return String(r.store_review_id) === id; }); });
        return good.length >= max && pinnedFound;
      }
      function page(n) {
        return fetch('https://api.reviews.io/merchant/reviews?per_page=100&page=' + n + '&store=' + encodeURIComponent(store))
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (d) {
            if (!d || !d.reviews) return null;
            if (!stats && d.stats) stats = d.stats;
            raw = raw.concat(d.reviews);
            var last = !d.total_pages || n >= d.total_pages || n >= maxPages || !d.reviews.length;
            if (last || enough()) return true;
            return page(n + 1);
          });
      }
      page(1)
        .then(function (ok) {
          clearTimeout(timer);
          if (!ok && !raw.length) return fail();
          if (stats && section) {
            var avg = parseFloat(stats.average_rating);
            var total = parseInt(stats.total_reviews, 10);
            if (avg > 0 && total > 0) {
              var v = section.querySelector('[data-mnz-reviews-summary] [data-mnz-rating-value]');
              var c = section.querySelector('[data-mnz-reviews-summary] [data-mnz-rating-count]');
              var f = section.querySelector('[data-mnz-reviews-summary] [data-mnz-rating-fill]');
              if (v) v.textContent = formatDe(avg, 2);
              if (c) c.textContent = formatDe(total, 0);
              if (f) f.style.width = Math.min(100, (avg / 5) * 100).toFixed(1) + '%';
            }
          }
          pool = pickReviews(raw, { fiveOnly: fiveOnly, pinned: pinned });
          if (!pool.length) return fail();
          // kam die Antwort erst nach dem Zeitlimit: Fallback wieder weg, Liste zeigen
          wrap.hidden = false;
          if (fallback) fallback.hidden = true;
          showNext(perPage);
          wrap.classList.add('is-loaded');
        })
        .catch(function () { clearTimeout(timer); fail(); });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); start(); }
      }, { rootMargin: '800px 0px' });
      io.observe(wrap);
    } else {
      start();
    }
  }

  /* ---------- R2: Höhe des klebenden Headers als CSS-Variable (Desktop-Galerie sticky) ---------- */
  function setHeaderVar() {
    var header = document.querySelector('.section-header, #shopify-section-header, .pageheader');
    var h = 0;
    if (header) {
      var pos = getComputedStyle(header).position;
      if (pos === 'sticky' || pos === 'fixed') h = Math.round(header.getBoundingClientRect().height);
    }
    document.documentElement.style.setProperty('--mnz-header-h', h + 'px');
  }

  function init(root) {
    root = root || document;
    $all(root, '[data-mnz-carousel]').forEach(initCarousel);
    $all(root, '.mnz-product .gallery.mnz-gallery--mobile-nav').forEach(initGalleryNav);
    $all(root, '.mnz-product .gallery').forEach(initGalleryLazy);
    initAiGlobal();
    $all(root, '[data-mnz-ai]').forEach(aiWire);
    initViewerBadge();
    initDeliveryDates(root);
    $all(root, '[data-mnz-rating]').forEach(initRating);
    $all(root, '[data-mnz-readmore-btn]').forEach(initReadMore);
    $all(root, '[data-mnz-compare]').forEach(initCompare);
    $all(root, '[data-mnz-reviews]').forEach(initReviews);
    if (root === document && document.querySelector && document.querySelector('.mnz-product')) {
      setHeaderVar();
      window.addEventListener('resize', setHeaderVar);
    }
  }

  window.MnzPdp = { init: init, formatDe: formatDe, formatDeliveryDate: formatDeliveryDate, formatFixedSetDelivery: formatFixedSetDelivery, hydrateImg: hydrateImg, pickReviews: pickReviews, isVerified: isVerified, reviewDate: reviewDate, reviewRules: { skip: REVIEW_SKIP, course: REVIEW_COURSE, prefer: REVIEW_PREFER } };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
